var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:_vm.iconStr(),style:({ 'font-size': _vm.getSize() }),attrs:{"title":_vm.title,"data-fa-transform":_vm.transform}})}
var staticRenderFns = []

export { render, staticRenderFns }